import { useContext, useEffect, useRef, useState } from "react";
import Banner from "../component/Banner";
import Testimonails from "../component/Testimonails";
import From from "../component/Form";
import axios from "axios";
import Loader from "../component/Loader";
import AOS from "aos";
import { Row, Col } from "antd";
import { IoIosArrowRoundForward } from "react-icons/io";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { RiInstagramFill } from "react-icons/ri";
import { FaFacebook } from "react-icons/fa6";
import { Link } from "react-router-dom";
import Card from "../component/card";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ProductContext } from "../context/productContext";
import { useSettings } from "../context/settingContext";
gsap.registerPlugin(ScrollTrigger);

function Home() {
    const { featuredProducts, mensProducts, womensProducts } = useContext(ProductContext)
    const [banner, setBanner] = useState(null);
    const [pageContent, setPageContent] = useState(null);
    const [cate, setCate] = useState(null);

    const getBanner = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}api/get-content/HomepageBanner`
            );
            setBanner(res.data.data[0]);
        } catch (err) {
            console.log("Fetching Banner Content", err);
        }
    };

    const getPageContent = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}api/get-content/Homepage`
            );
            setPageContent(res.data.data);
        } catch (err) {
            console.log("Fetching Page Content", err);
        }
    };

    const getCate = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-all-categories`)
            setCate(res.data.data)
        } catch (err) {
            console.log('Fetching Category Data', err)
        }
    }

    useEffect(() => {
        getBanner();
        getPageContent();
        getCate();
    }, []);

    useEffect(() => {
        AOS.init({
            duration: 700,
            easing: "ease-out-cubic",
            once: true,
            mirror: false,
        });
    }, []);

    const slidesRef = useRef([]);

    useEffect(() => {
        slidesRef.current.forEach((slide, i) => {
            if (!slide) return;
            gsap.fromTo(
                slide,
                { opacity: 0, y: 50 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    delay: i * 0.2,
                    scrollTrigger: {
                        trigger: slide,
                        start: "top 85%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });
    }, []);

    const [wishlist, setWishlist] = useState([]);
    const { user } = useSettings();
    const userId = user?.id;

    useEffect(() => {
        const fetchWishlist = async () => {
            if (!userId) return;
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}api/listing-wishlist?user_id=${userId}`);
                setWishlist(res.data.data || []);
            } catch (err) {
                console.log("Error fetching wishlist:", err);
            }
        };
        fetchWishlist();
    }, [userId]);

    const imageRef = useRef(null);
    const textRef = useRef(null);

    useEffect(() => {
        if (imageRef.current && textRef.current) {
            gsap.fromTo(
                imageRef.current,
                { opacity: 0, x: -100 },
                {
                    opacity: 1,
                    x: 0,
                    duration: 1.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: "top 80%",
                        toggleActions: "play none none none",
                    },
                }
            );
            gsap.fromTo(
                textRef.current,
                { opacity: 0, y: 100 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 1.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: textRef.current,
                        start: "top 85%",
                        toggleActions: "play none none none",
                    },
                }
            );
        }
    }, [])

    if (banner === null || pageContent === null || cate === null) {
        return <Loader />;
    }

    return (
        <>
            <Banner
                Title={banner.title}
                secttile={banner.sub_title}
                dec1={banner.short_details}
                dec2={banner.details}
                img={`${process.env.REACT_APP_SITE_IMAGES}${banner.image}`}
            />
            <div className="bg-black py-8">
                <h2 className="font-syne text-4xl text-center font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent m-auto w-full max-w-[500px] leading-tight mb-10">
                    {pageContent[0].details}
                </h2>
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={2}
                    breakpoints={{
                        640: { slidesPerView: 3 },
                        768: { slidesPerView: 4 },
                        1024: { slidesPerView: 7 },
                    }}
                    navigation
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 2500, disableOnInteraction: false }}
                    className="my-10"
                >
                    {cate.map((item, index) => (
                        <SwiperSlide key={index}>
                            <li
                                className="flex flex-col items-center"
                                data-aos="fade-up"
                                data-aos-delay={index * 80}
                                data-aos-offset="120"
                            >
                                <Link
                                    to={`/categrios/${item.id}`}
                                    className="flex flex-col items-center group"
                                >
                                    <img
                                        src={`${process.env.REACT_APP_SITE_IMAGES}${item.photo}`}
                                        alt={item.name}
                                        className="w-32 h-32 object-cover rounded-lg shadow-lg group-hover:scale-105 transition-transform"
                                    />
                                    <p className="mt-2 font-syne font-medium text-center text-white group-hover:bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(1,14,1,12)_100%)] group-hover:bg-clip-text group-hover:text-transparent transition">
                                        {item.name}
                                    </p>
                                </Link>
                            </li>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="main-droper bg-black pt-20 pb-20">
                <div className="conatiner mx-auto px-4">
                    <Row gutter={20} className="crafted-row motion-flex  align-items-center">
                        <Col span={8}>
                            <div className="text-1">
                                <h1 className='font-syne text-4xl font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent'>
                                    {pageContent[1].title}
                                </h1>
                                <p className='text-[15px] font-outfit  text-white pt-[25px] pt-5 pb-5 text-white w-[480px]'>
                                    {pageContent[1].details}
                                </p>
                                <Link to="/shop" className="bg-white font-syne w-fit p-3 font-thin rounded-full outline-none flex items-center justify-between gap-2 hover:bg-[linear-gradient(90deg,_rgba(67,170,214,1)_0%,_rgba(0,0,0,1)_100%)] hover:text-white transition-all duration-300"
                                >
                                    <span className="font-medium hover:text-white"
                                    >Shop the Collection</span>
                                    <IoIosArrowRoundForward className="text-xl" />
                                </Link>
                            </div>
                        </Col>

                        <Col span={16} className=''>
                            <Swiper
                                modules={[Navigation]}
                                navigation
                                margin={20}
                                width={1000}
                                slidesPerView={3}
                                className="crafted-swiper"
                            >
                                {mensProducts.map((product, index) => (
                                    <SwiperSlide key={index}>
                                        <div ref={(el) => (slidesRef.current[index] = el)}>
                                            <Card
                                                key={product.id} {...product}
                                                isWishlisted={
                                                    wishlist.some((item) => item.item_id === product.id)
                                                }
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className="bg-black pt-20 pb-20">
                <div className="container mx-auto px-4">
                    <div className="banner-text">
                        <h2 className="font-syne text-8xl text-center font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent m-auto w-full max-w-[900px]">
                            {pageContent[2].title}
                        </h2>
                        <p className="font-outfit text-center text-white pt-[25px]">
                            {pageContent[2].details}
                        </p>
                    </div>

                    <div className="mt-16 w-full">
                        <Swiper
                            modules={[Navigation]}
                            navigation
                            spaceBetween={30}
                            slidesPerView={4}
                            className="crafted-swiper w-full">
                            {featuredProducts.map((product, index) => (
                                <SwiperSlide key={index}>
                                    <div ref={(el) => (slidesRef.current[index] = el)}>
                                        <Card
                                            key={product.id}
                                            {...product}
                                            isWishlisted={
                                                wishlist.some((item) => item.item_id === product.id)
                                            }
                                        />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
            <div className='bg-black'>
                <div className="container mx-auto px-4 pt-20 pb-20">
                    <Row gutter={50} className="essence-row motion-flex align-items-center">
                        <Col span={12}>
                            <div className="banner-images" ref={imageRef}>
                                <img src={`${process.env.REACT_APP_SITE_IMAGES}${pageContent[3].image}`} alt="Essence" />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="banner-text" ref={textRef}>
                                <h2 className='font-syne text-5xl text-start font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent w-[600px]'>
                                    {pageContent[3].title}
                                </h2>
                                <p className='text-white font-outfit pt-5 text-[20px] pb-5'>
                                    {pageContent[3].details}
                                </p>
                                <Link to="/shop" className="bg-white font-syne w-fit p-3 font-thin rounded-full outline-none flex items-center justify-between gap-2 hover:bg-[linear-gradient(90deg,_rgba(67,170,214,1)_0%,_rgba(0,0,0,1)_100%)] hover:text-white transition-all duration-300">
                                    <span className="font-medium hover:text-white">Shop the Collection</span>
                                    <IoIosArrowRoundForward className="text-xl" />
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className="main-droper bg-black pt-20 pb-20">
                <div className="conatiner mx-auto px-4">
                    <Row gutter={20} className="crafted-row motion-flex  align-items-center">
                        <Col span={8}>
                            <div className="text-1">
                                <h1 className='font-syne text-4xl font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent'>
                                    {pageContent[4].title}
                                </h1>
                                <p className='text-[15px] font-outfit  text-white pt-[25px] pt-5 pb-5 text-white w-[480px]'>
                                    {pageContent[4].details}
                                </p>
                                <Link to="/shop" className="bg-white font-syne w-fit p-3 font-thin rounded-full outline-none flex items-center justify-between gap-2 hover:bg-[linear-gradient(90deg,_rgba(67,170,214,1)_0%,_rgba(0,0,0,1)_100%)] hover:text-white transition-all duration-300"
                                >
                                    <span className="font-medium hover:text-white"
                                    >Shop Women’s Collection</span>
                                    <IoIosArrowRoundForward className="text-xl" />
                                </Link>
                            </div>
                        </Col>

                        <Col span={16} className=''>
                            <Swiper
                                modules={[Navigation]}
                                navigation
                                margin={20}
                                width={1000}
                                slidesPerView={3}
                                className="crafted-swiper"
                            >
                                {womensProducts.map((product, index) => (
                                    <SwiperSlide key={index}>
                                        <div ref={(el) => (slidesRef.current[index] = el)}>
                                            <Card
                                                key={product.id}
                                                {...product}
                                                isWishlisted={
                                                    wishlist.some((item) => item.item_id === product.id)
                                                }
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className="bg-black pt-20 pb-20">
                <div className="container mx-auto px-4">
                    <div className="banner-text">
                        <h2 className="font-syne text-8xl text-center font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent m-auto w-full max-w-[900px]">
                            {pageContent[5].title}
                        </h2>
                        <p className="font-outfit text-center text-white pt-[25px]">
                            {pageContent[5].details}
                        </p>
                    </div>

                    <div className="mt-16 w-full">
                        <Swiper
                            modules={[Navigation]}
                            navigation
                            spaceBetween={30}
                            slidesPerView={4}
                            className="crafted-swiper w-full"
                        >
                            {featuredProducts.map((product, index) => (
                                <SwiperSlide key={index}>
                                    <div ref={(el) => (slidesRef.current[index] = el)}>
                                        <Card
                                            key={product.id}
                                            {...product}
                                            isWishlisted={
                                                wishlist.some((item) => item.item_id === product.id)
                                            }
                                        />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
            <Testimonails
                tilte={pageContent[6].title}
                tagline={pageContent[6].details}
            />
            <div className="min-h-screen bg-black text-white flex items-center justify-center">
                <div className="container mx-auto px-4 py-16">
                    <Row gutter={[32, 32]} align="middle" justify="space-between">
                        <Col xs={24} md={10}>
                            <h1 className="text-[184px] font-bold font-syne bg-[linear-gradient(90deg,_rgba(67,170,214,1)_80%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent">
                                <span className="font-syne text-[184px] bg-[linear-gradient(90deg,_rgba(67,170,214,1)_80%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent">
                                    {pageContent[7].title}
                                </span>
                            </h1>
                            {/* <div className="mt-6 flex gap-4 text-blue-400 text-xl">
                                <a href="#" target="_blank" rel="noopener noreferrer">
                                    <RiInstagramFill />
                                </a>
                                <a href="#" target="_blank" rel="noopener noreferrer">
                                    <FaFacebook />
                                </a>
                            </div> */}
                        </Col>
                        <Col xs={24} md={14}>
                            <div className="bg-gradient-to-br from-[#1f1f1f] to-[#2b2b2b] backdrop-blur-md p-8 rounded-2xl shadow-lg">
                                <From des={pageContent[7].details} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
}

export default Home;
